/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  List,
  SiteInsightsEvent,
  SiteInsightsQueryEventsAggregation,
  SiteInsightsQueryEventsAggregationResult,
  SiteInsightsVisitorSegment,
} from "./data-contracts";

/**
 * No description
 * @tags site-insights
 * @name TrackEventsInSiteById
 * @summary Track site events
 * @request POST:/orgs/{organizationId}/sites/{siteId}/insights/events
 * @secure
 */

// @ts-ignore
export const trackEventsInSiteById: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    events: SiteInsightsEvent[];
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/insights/events",
  method: "post",
  streaming: false,
  tags: ["site-insights"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-insights
 * @name AggregateSiteEvents
 * @summary Query site events
 * @request POST:/orgs/{organizationId}/sites/{siteId}/insights/events/aggregate
 * @secure
 */

// @ts-ignore
export const aggregateSiteEvents: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: SiteInsightsQueryEventsAggregation;
  RequestHeaders: {};
  ResponseBody: SiteInsightsQueryEventsAggregationResult;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/insights/events/aggregate",
  method: "post",
  streaming: false,
  tags: ["site-insights"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-insights
 * @name ListSiteVisitorSegments
 * @summary List a site visitor segments
 * @request GET:/orgs/{organizationId}/sites/{siteId}/insights/visitor-segments
 * @secure
 */

// @ts-ignore
export const listSiteVisitorSegments: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteInsightsVisitorSegment[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/insights/visitor-segments",
  method: "get",
  streaming: false,
  tags: ["site-insights"],
  criticalityLevel: "low",
  deprecated: false,
};
